module.exports = __webpack_public_path__ + "static/media/dashboard.5d20338e.svg";